export default __webpack_public_path__ + "static/media/Jennell_Lynch_AHV_In_Moms_We_Trust.94738c24.jpg";